import React from "react";
import { TextField, Grid } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { isArray } from "lodash";

const FilterTemplate = ({ filter, filterData }) => {
  return (
    <div style={{display:"flex",justifyContent:"flex-start",gap:"10px"}}>
      {filterData &&
        filterData.length > 0 &&
        filterData.map((filter, index) => (
          <div key={index} style={{ width: "250px" }}>
            <Autocomplete
              options={isArray(filter?.options) ? filter?.options : []}
              className="user"
              margin="dense"
              size="small"
              fullWidth
              value={filter?.value || ""}
              getOptionLabel={(option) => (option ? filter?.type ==="number"? option?.number:option?.name || "" : "")}
              onChange={(event, newValue) => {
                filter?.function && filter.function(event, newValue);
              }}
              variant="outlined"
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder={filter?.label || ""}
                  variant="outlined"
                  margin="dense"
                  style={{ background: "#fff" }}
                />
              )}
            />
          </div>
        ))}
    </div>
  );
};

export default FilterTemplate;
